import React, {useEffect, useState, useMemo} from 'react';
import {
  Stack, 
   Typography,   Box,
   
} from '@mui/material';


import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Tty';

const name_start_display_length = 2;
const phone_start_display_length = 4;
const email_start_display_length = 4;



const RenderVisitorName =   ( {props, option} ) =>
{
    return (

        <Stack  {...props}  sx={{display:'flex', flexWrap: 'wrap',  flexDirection:'column',  
                      justifyContent:'left', alignContent:'left',
                      alignItems:'left',  borderBottom:0.5, borderColor:'#CCCCCC'}} 
                      
                      >
                    <Box sx={{display:'flex', flexDirection:'row', width:'100%' }}> 
                     <PersonIcon sx={{width:20, height:20}} color='primary'/>
                    {option.name}
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                          
                          {/** 
                          <EmailIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                          */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.email}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                          {/** 
                          <PhoneIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                          */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.phone}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                          {/** 
                          <CompanyIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                        */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.company}</i>
                          </Typography>
                    </Box>

                  </Stack>
    )


}



const RenderVisitorPhone =   ( {props, option} ) =>
{
    return (

        <Stack  {...props}  sx={{display:'flex', flexWrap: 'wrap',  flexDirection:'column',  
                      justifyContent:'left', alignContent:'left',
                      alignItems:'left',  borderBottom:0.5, borderColor:'#CCCCCC'}} 
                      
                      >
                    <Box sx={{display:'flex', flexDirection:'row', width:'100%' }}> 
                     <PhoneIcon sx={{width:20, height:20}} color='primary'/>
                    {option.phone}
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                      {/** 
                          <PersonIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                      */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.name}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                           {/**
                             <EmailIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                            */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.email}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                           {/**
                            <CompanyIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                          */}
                            <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.company}</i>
                          </Typography>
                    </Box>

                  </Stack>
    )


}

const RenderVisitorEmail =   ( {props, option} ) =>
{
    return (

        <Stack  {...props}  sx={{display:'flex', flexWrap: 'wrap',  flexDirection:'column',  
                      justifyContent:'left', alignContent:'left',
                      alignItems:'left',  borderBottom:0.5, borderColor:'#CCCCCC'}} 
                      
                      >
                    <Box sx={{display:'flex', flexDirection:'row', width:'100%' }}> 
                     <EmailIcon sx={{width:20, height:20}} color='primary'/>
                    {option.email}
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                           {/**
                            <PersonIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                          */}
                            <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.name}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                           {/**
                            <PhoneIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                        */}  
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.phoneDisplay}</i>
                          </Typography>
                    </Box>
                    <Box sx={{display:'flex', flexDirection:'row', width: '100%' }}> 
                           {/**
                            <CompanyIcon sx={{width:16, height:16, color:'primary.light', fontSize:12}} />
                      */}
                          <Typography variant='body2' sx={{color:'#999999'}}>

                            <i>{option.company}</i>
                          </Typography>
                    </Box>

                  </Stack>
    )


}


const filterVisitorNameOptions = (options, state) => {

    let newOptions = [];
    
    if (!Boolean(state.inputValue)) return newOptions

    let aa = state.inputValue.toLowerCase();
    if (aa.length<name_start_display_length)    return newOptions
    
    options.forEach((element) => {
      if (
        element.name.toLowerCase().includes(aa)
      )
        newOptions.push(element);
    });
    return newOptions;
  };

  const filterVisitorPhoneOptions = (options, state) => {

    let newOptions = [];
    
    if (!Boolean(state.inputValue)) return newOptions

    let aa = state.inputValue.toLowerCase();
    if (aa.length<phone_start_display_length)    return newOptions
    
    options.forEach((element) => {
      if (
        element.phone.includes(aa)
      )
        newOptions.push(element);
    });
    return newOptions;
  };
  const filterVisitorEmailOptions = (options, state) => {

    let newOptions = [];
    
    if (!Boolean(state.inputValue)) return newOptions

    let aa = state.inputValue.toLowerCase();
    if (aa.length<email_start_display_length)    return newOptions
    
    options.forEach((element) => {
      if (
        element.email.toLowerCase().includes(aa)
      )
        newOptions.push(element);
    });
    return newOptions;
  };

export {RenderVisitorPhone, RenderVisitorName, RenderVisitorEmail, 
  
  filterVisitorNameOptions,
  filterVisitorPhoneOptions,  filterVisitorEmailOptions
}